var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgConnectionPink(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "nc-icon-wrapper",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    fill: "none",
    stroke: "#422d8f"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M21.645,9.999C22.476,10.732,23,11.805,23,13v4c0,2.209-1.791,4-4,4h-9c-2.209,0-4-1.791-4-4v-4c0-2.209,1.791-4,4-4h4",
    stroke: "#422d8f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.355,14.001 C1.524,13.268,1,12.195,1,11V7c0-2.209,1.791-4,4-4h9c2.209,0,4,1.791,4,4v4c0,2.209-1.791,4-4,4h-4"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConnectionPink);
export default __webpack_public_path__ + "static/media/connectionPink.5e6f797880cab26c008b869cdf9c9fd0.svg";
export { ForwardRef as ReactComponent };